/* eslint-disable array-callback-return */
/* eslint-disable react/destructuring-assignment */
import { Header } from './header';
import { ReportContext } from './hooks/use-context';
import { InitialInfos } from './initial-infos';
import { Labels } from './labels';
import { Members } from './members';
import { Pictures } from './pictures';
import { Table } from './table';
import type {
  EventReportData,
  ParsedQuestions,
  QuestionData,
  QuestionsReporData,
} from './types';

export function ChecklistVerificacaoFerramentasReport(props: {
  reportData: EventReportData;
}) {
  const QUESTIONS_MAP: Record<string, keyof ParsedQuestions> = {
    'ae8c60a8-bc8e-400b-9ec5-f7e6fa8072be': 'conjunto_oxiacetileno_empresa',
    '88317c70-4421-44f4-bc27-0b76673f0330': 'empresa_terceira',
    '949a7223-7312-4bc1-95ed-2046eead2f65': 'nome_participante_terceiro',
    '48a2a99a-c621-4144-8c3b-e0346e85ef9d': 'conjunto_oxiacetileno',
    '1a36edff-e458-4db9-b7d5-900c918781ef': 'qtd_ferramentas',
    '03d2478b-d90b-43c4-9729-594dd8dee615': 'qtd_ferramentas_inspecionadas',
    // ... "Outros" Section
    '5226533d-8082-49b5-a469-64813c9d79c2': 'observacoes_gerais',
    '701f0754-41b3-4d81-8a23-e23266836b21': 'registro_fotografico',
    '457e0670-04c2-4ede-87a0-1a7602c47f12': 'outras_situacoes',
  };

  const values = Array.isArray(props?.reportData?.body)
    ? props?.reportData?.body?.[0]?.sections?.reduce(
        (acc: Partial<ParsedQuestions>, section) => {
          section?.questions?.forEach((question: QuestionData) => {
            if (question?.question_id && QUESTIONS_MAP[question.question_id]) {
              acc[QUESTIONS_MAP[question.question_id]] = question;
            }
          });
          return acc;
        },
        {} as Partial<ParsedQuestions>,
      )
    : {};

  const parsedProps: QuestionsReporData = {
    header: props?.reportData?.header,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    body: Array.isArray(props?.reportData?.body)
      ? props?.reportData?.body[0]
      : (props?.reportData?.body as any),
    values,
  };

  return (
    <ReportContext.Provider value={parsedProps}>
      <div style={{ breakAfter: 'page' }}>
        <div
          style={{
            height: '90%',
            width: '100vw',
            flex: 1,
            backgroundColor: 'white',
            fontFamily: 'sans-serif',
          }}
        >
          <div
            style={{
              margin: '1rem auto',
              height: 'auto',
              maxWidth: '64rem',
            }}
          >
            <Header formName={parsedProps.body?.form_name} />
            <div
              style={{
                height: '100%',
                width: '100%',
                borderRadius: '2px',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: '#000',
                backgroundColor: '#fff',
                marginBottom: '1rem',
              }}
            >
              <InitialInfos />
              <Table />
              <Labels />
              <Members />
            </div>

            <Pictures />
          </div>
        </div>
      </div>
    </ReportContext.Provider>
  );
}
